import axios from 'axios';

const state = {

};

const getters = {
};

const actions = {
    async getPendingApplication(state) {// get remita payment status
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getPendingApplicationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {}, { headers: header});// make api call
        return response.data;
    },
    async updateHospitalData(state, data) {// get remita payment status
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.updateHospitalDataUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async deleteHospitalData(state, data) {// get remita payment status
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.deleteHospitalDataUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async submitVerificationApplication(state, id) {// get remita payment status
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.submitVerificationApplicationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, { id : id }, { headers: header});// make api call
        return response.data;
    },
    async getHospitalApplications(state, data) {// get remita payment status
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getHospitalApplicationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async getApplication(state, id) {// get remita payment status
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getApplicationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, { id: id }, { headers: header});// make api call
        return response.data;
    },
    async getPaginatedApplicationItems(state, url) {// get paginated applications
        const authorizationToken = state.rootState.user.accessToken;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, {}, { headers: header});// make api call
        return response.data;
    },
    async requestVerifyVisit(state, data) {// get remita payment status
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.requestVerifyVisitUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    }
};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}